import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { disableFocusBehindModal, enableFocusBehindModal } from '../../helpers/modalHelper';

class Overlay {
    constructor(content, settings) {
        this.settings = {
            delay: settings.delay || 0,
            coverHeader: settings.coverHeader || false,
            closeOnBackgroundClick: settings.closeOnBackgroundClick || true,
            cssClass: settings.cssClass || ''
        } 
        this.content = content;
        this.overlayTemplate = `<div class="overlay ${this.settings.cssClass}" id="Overlay"><div class="overlay__container"><div class="overlay__container__content"></div></div></div>`;
        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
        this.handleEscKey = this.handleEscKey.bind(this);
        this.removeEventListeners = this.removeEventListeners.bind(this);
        this.addEventListeners = this.addEventListeners.bind(this);
    }
    open() {
        return new Promise((resolve) => {
            document.body.insertAdjacentHTML('afterbegin', this.overlayTemplate);
            document.body.classList.add('overlay-open');
            let overlay = document.getElementById('Overlay');
            let container = overlay.children[0].children[0];
            container.insertAdjacentHTML('afterbegin', this.content);            
            if(this.settings.coverHeader) {
                overlay.classList.add('overlay--cover-header');
            }
            this.addEventListeners(overlay)
            disableBodyScroll(overlay);
            disableFocusBehindModal(overlay);            
            overlay.classList.add('overlay--complete');        
            resolve(overlay);
        });
    }
    close() {
        let overlay = document.getElementById('Overlay');
        document.body.classList.remove('overlay-open');
        if(overlay) {
            overlay.classList.remove('overlay--complete');
            setTimeout(() => {
                overlay.remove();
            }, this.settings.delay);            
            this.removeEventListeners(overlay);
            enableBodyScroll(overlay);
            enableFocusBehindModal(overlay);
        }
    }
    addEventListeners(overlay) {
        document.addEventListener('keydown', this.handleEscKey);
        if(this.settings.closeOnBackgroundClick) {
            overlay.children[0].addEventListener('click', this.close);
            overlay.children[0].children[0].addEventListener('click', this.handleChildClick);            
        }
    }
    removeEventListeners(overlay) {
        document.removeEventListener('keydown', this.handleEscKey);
        if(this.settings.closeOnBackgroundClick) {
            overlay.children[0].removeEventListener('click', this.close);
            overlay.children[0].children[0].removeEventListener('click', this.handleChildClick);            
        }
    }
    handleEscKey(e) {
        if (e.key === 'Escape') {
            this.close();
        }
    }
    handleChildClick(e) {
        e.stopPropagation();
    }
}

export default Overlay;